import { render, staticRenderFns } from "./DianJinDetail.vue?vue&type=template&id=4adc04ee&scoped=true&"
import script from "./DianJinDetail.vue?vue&type=script&lang=js&"
export * from "./DianJinDetail.vue?vue&type=script&lang=js&"
import style0 from "./DianJinDetail.vue?vue&type=style&index=0&id=4adc04ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4adc04ee",
  null
  
)

export default component.exports